// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { PopupForm } from './popup-form';

/**
 * @class Jsw.CustomDescription.PopupForm
 * @extends Jsw.PopupForm
 */
export const CustomDescription = {};
CustomDescription.PopupForm = Class.create(PopupForm, {
    _initConfiguration($super, config) {
        $super(config);
        this._hint = this._getConfigParam('hint', '');
        this._value = this._getConfigParam('value', '');
        this._handler = this._getConfigParam('handler', null);
        this._sendButtonId = this._getConfigParam('sendButtonId', 'btn-send');
        this._cancelButtonId = this._getConfigParam('cancelButtonId', 'btn-cancel');
    },

    render($super) {
        $super();

        this.setBoxType('form-box');
        this.setTitle(this.lmsg('popupTitle'));
        this.setTitleType(this._getConfigParam('titleCls', 'pp-edit-description'));

        $(this._contentAreaId).update(
            `<p>${this._hint}</p>` +
            `<textarea id="${this._id}-description" class="js-auto-resize" rows="4" maxlength="255" cols="80">${this._value}</textarea>`
        );

        this.addOkButton();
        this.addCancelButton();
    },

    addOkButton() {
        this.addRightButton(this.lmsg('buttonOk'), this._onOkClick, true, true, { id: this._sendButtonId });
    },

    addCancelButton() {
        this.addRightButton(this.lmsg('buttonCancel'), this._onCancelClick, false, false, { id: this._cancelButtonId });
    },

    _onOkClick() {
        this._handler($(`${this._id}-description`).value);
        this.hide();
    },

    _onCancelClick() {
        this.hide();
    },
});



// WEBPACK FOOTER //
// ./jsw/custom-description.js